import React from 'react';
import PropTypes from 'prop-types';

function Notification({ title, desc }) {
    return (
        <div className="detail">
            <h2>{title}</h2>
            <p>{desc}</p>
        </div>
    );
}

Notification.propTypes = {
    title: PropTypes.string,
    desc: PropTypes.string,
};

Notification.defaultProps = {
    title: '',
    desc: '',
};

export default Notification;
